import { createContext, useCallback } from 'react';

export const UserContext = createContext({
  user: null,
  setUser: ({}) => {},
  userToken: null,
  setUserToken: ({}) => {},
  isUserLoading: true,
  userTags: {},  // Added userTags to store image tags
  setUserTags: (tags) => {}  // Function to update tags
});
